import { render, staticRenderFns } from "./OrtopediHastaDetay.vue?vue&type=template&id=a9a9f426&scoped=true&"
import script from "./OrtopediHastaDetay.vue?vue&type=script&lang=js&"
export * from "./OrtopediHastaDetay.vue?vue&type=script&lang=js&"
import style0 from "./OrtopediHastaDetay.vue?vue&type=style&index=0&id=a9a9f426&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a9f426",
  null
  
)

export default component.exports